"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.Actions = void 0;
var _react = _interopRequireDefault(require("react"));
var _intl = require("@kyruus/intl");
var _providerComponents = require("@kyruus/provider-components");
var _globals = require("../../../lib/constants/globals");
var _styles = require("../styles");
var _Warning = require("./Warning");
var _BookingButton = require("./BookingButton");
var _ViewAvailabilityButton = require("./ViewAvailabilityButton");
var _BookingInfo = require("./BookingInfo");
var _useMediaQuery = _interopRequireDefault(require("@mui/material/useMediaQuery"));
var _uiTheme = _interopRequireDefault(require("@kyruus/ui-theme"));
const Actions = _ref => {
  let {
    provider,
    modalDisplay,
    bookingCallback,
    shouldDisplayAvailability,
    slotsStatus,
    track,
    config,
    isBookingDisabled,
    showWarning,
    bookingWarning,
    onClickShowAvailability,
    locations,
    summaryUrl,
    showWaitTimeLink
  } = _ref;
  const isScreenLargeOrAbove = (0, _useMediaQuery.default)(`(min-width:${_uiTheme.default.screen_large})`);
  const waitTimeLink = isScreenLargeOrAbove ? summaryUrl : `${summaryUrl}#estimated-wait-time-section`;
  return /*#__PURE__*/_react.default.createElement(_styles.ActionsContainer, {
    showWarning: showWarning,
    "data-testid": "provider-tile-booking-actions"
  }, showWarning && /*#__PURE__*/_react.default.createElement(_Warning.Warning, {
    bookingWarning: bookingWarning
  }), showWaitTimeLink && /*#__PURE__*/_react.default.createElement(_styles.StyledWaitTimeLink, {
    href: waitTimeLink,
    mode: "secondary",
    withSlots: false
  }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _providerComponents.messages.estimatedWaitTimeButtonLinkName)), /*#__PURE__*/_react.default.createElement(_BookingButton.BookingButton, {
    provider: provider,
    modalDisplay: modalDisplay,
    bookingCallback: bookingCallback,
    track: track,
    disabled: isBookingDisabled
  }), slotsStatus !== _globals.SLOTS_SUCCESS_STATUS && /*#__PURE__*/_react.default.createElement(_ViewAvailabilityButton.ViewAvailabilityButton, {
    providerId: provider.id,
    onClickShowAvailability: onClickShowAvailability,
    shouldDisplayAvailability: shouldDisplayAvailability,
    locations: locations,
    disabled: slotsStatus === _globals.SLOTS_LOADING_STATUS,
    track: track
  }), /*#__PURE__*/_react.default.createElement(_BookingInfo.BookingInfo, {
    provider: provider,
    shouldDisplayAvailability: shouldDisplayAvailability,
    slotsStatus: slotsStatus,
    config: config
  }));
};
exports.Actions = Actions;
Actions.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Actions"
};